// 단체 통화 부수 장치: 벨소리·연결음, 화면 켜짐 유지, 당겨서 새로고침 차단
// 엔진 상태(phase) 변화만 보고 동작한다. 1:1 통화 코드와 공유하는 상태는 없다.
import { startRingtone, startRingbackTone, stopAllCallSounds } from '../utils/callSounds';

const SOUND_PHASES = ['incoming', 'outgoing'];

export function startGroupCallSideEffects(subscribe) {
  if (typeof subscribe !== 'function') return () => {};
  let prevPhase = 'idle';
  let wakeLock = null;
  let wakeLockRequesting = false;
  let savedOverscroll = null;

  function acquireWakeLock() {
    if (typeof navigator === 'undefined' || typeof navigator.wakeLock?.request !== 'function') return;
    if (wakeLockRequesting || (wakeLock && wakeLock.released === false)) return;
    wakeLockRequesting = true;
    navigator.wakeLock
      .request('screen')
      .then((sentinel) => {
        if (prevPhase !== 'active') {
          sentinel.release().catch(() => {});
          return;
        }
        wakeLock = sentinel;
        sentinel.addEventListener('release', () => {
          if (wakeLock === sentinel) wakeLock = null;
        });
      })
      .catch((err) => {
        if (import.meta.env.DEV) console.warn('[단체 통화] 화면 켜짐 유지 실패:', err?.name);
      })
      .finally(() => {
        wakeLockRequesting = false;
      });
  }

  function releaseWakeLock() {
    if (wakeLock) {
      wakeLock.release().catch(() => {});
      wakeLock = null;
    }
  }

  function lockOverscroll() {
    if (savedOverscroll || typeof document === 'undefined') return;
    savedOverscroll = {
      html: document.documentElement.style.overscrollBehavior,
      body: document.body.style.overscrollBehavior,
    };
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overscrollBehavior = 'none';
  }

  function unlockOverscroll() {
    if (!savedOverscroll || typeof document === 'undefined') return;
    document.documentElement.style.overscrollBehavior = savedOverscroll.html;
    document.body.style.overscrollBehavior = savedOverscroll.body;
    savedOverscroll = null;
  }

  function onPhase(phase) {
    if (phase === prevPhase) return;
    const before = prevPhase;
    prevPhase = phase;
    // 소리: 받는 중이면 벨소리, 거는 중이면 연결음, 그 둘에서 벗어나면 끈다
    if (phase === 'incoming') startRingtone();
    else if (phase === 'outgoing') startRingbackTone();
    else if (SOUND_PHASES.includes(before)) stopAllCallSounds();
    // 화면 켜짐 유지: 통화 중(active)일 때만
    if (phase === 'active') acquireWakeLock();
    else releaseWakeLock();
    // 당겨서 새로고침 차단: 대기(idle)가 아니면 켠다
    if (phase === 'idle') unlockOverscroll();
    else lockOverscroll();
  }

  const unsubscribe = subscribe((s) => {
    try {
      onPhase(s?.phase || 'idle');
    } catch (e) {
      if (import.meta.env.DEV) console.warn('[단체 통화] 부수 장치 처리 실패:', e);
    }
  });

  // 화면이 가려지면 브라우저가 화면 켜짐을 풀기 때문에 복귀 시 다시 건다
  const onVisible = () => {
    if (document.visibilityState === 'visible' && prevPhase === 'active') acquireWakeLock();
  };
  if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisible);

  return () => {
    if (typeof unsubscribe === 'function') unsubscribe();
    if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisible);
    if (SOUND_PHASES.includes(prevPhase)) stopAllCallSounds();
    releaseWakeLock();
    unlockOverscroll();
    prevPhase = 'idle';
  };
}
